module.exports = __webpack_public_path__ + "static/img/jineixiananchanliang.b25c1922.png";